import StartOverButton from "../startOverButton";
import React from "react";
import {setCurrentStep} from "../../actions";
import {useDispatch} from "react-redux";

export function StepIndicator({title, previous = false, prevStep = 0}) {

    const dispatch = useDispatch();

    let titleInfo = previous && prevStep !== 0
        ? (
            <a className="previous-step"
               href = "#"
               onClick={
                   (e) => {
                       e.preventDefault();
                       dispatch(setCurrentStep(prevStep));
                   }
               }>Previous step</a>
        )
        : (
            <span className="form-subheader">{title}</span>
        );


    return (
        <div className="step-indicator">
            {titleInfo}
            <StartOverButton />
        </div>
    )
}
